import type { FC } from 'react';

import type { StackedNumbersList } from 'src/components/followUp/common/types';

import BarTable from './components/BarTable/BarTable';
import { useTransformData } from './hooks';

interface ComparisonTableChartProps {
  data: StackedNumbersList;
}

const ComparisonTableChart: FC<ComparisonTableChartProps> = ({ data }) => {
  const { dataCalculated, labels } = useTransformData(data);

  return (
    <BarTable
      data={dataCalculated}
      aggregateLabels={labels.map((label) => label.toString())}
      firstColumnWidth="30%"
    />
  );
};

export default ComparisonTableChart;
